var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuSettingsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.30692 3.43861C10.0803 0.728797 13.9206 0.728797 14.6939 3.43861C15.1088 4.89223 16.6022 5.75445 18.0685 5.38691C20.8019 4.70174 22.7221 8.02756 20.762 10.0522C19.7106 11.1383 19.7106 12.8627 20.762 13.9488C22.7221 15.9734 20.8019 19.2993 18.0685 18.6141C16.6022 18.2466 15.1088 19.1088 14.6939 20.5624C13.9206 23.2722 10.0803 23.2722 9.30692 20.5624C8.89208 19.1088 7.39866 18.2466 5.93237 18.6141C3.19893 19.2993 1.27876 15.9734 3.23886 13.9488C4.29031 12.8627 4.29031 11.1383 3.23886 10.0522C1.27876 8.02756 3.19893 4.70174 5.93237 5.38691C7.39866 5.75445 8.89208 4.89223 9.30692 3.43861Z",
    stroke: "#1A1A1A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00043 12.0005C9.00043 13.6574 10.3436 15.0005 12.0004 15.0005C13.6573 15.0005 15.0004 13.6574 15.0004 12.0005C15.0004 10.3436 13.6573 9.0005 12.0004 9.0005C10.3436 9.0005 9.00043 10.3436 9.00043 12.0005Z",
    stroke: "#1A1A1A",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuSettingsIcon);
export default __webpack_public_path__ + "static/media/menu-settings-icon.c7a8a81b.svg";
export { ForwardRef as ReactComponent };